/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemsGrid_item = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsContainer_item">;
    readonly " $refType": "PdpRespSimilarItemsGrid_item";
};
export type PdpRespSimilarItemsGrid_item$data = PdpRespSimilarItemsGrid_item;
export type PdpRespSimilarItemsGrid_item$key = {
    readonly " $data"?: PdpRespSimilarItemsGrid_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsGrid_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarItemsGrid_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsContainer_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = 'efbb932a9407ab6f063da060d8201fdd';
export default node;
